import { Box, Button, Popover, Typography } from "@mui/material"
import { MouseEventHandler, useState } from "react"
import { PropsPopoverButtons } from "./types"
import { useStyles } from "./styles"

const PopoverButtons = ({ list, styleType, buttonLabel }: PropsPopoverButtons) => {

    const styles = useStyles({ removeMargin: true })
    const [open, setOpen] = useState(false)
    const [anchor, setAnchor] = useState<EventTarget & HTMLButtonElement>()
    const handleOpen: MouseEventHandler<HTMLButtonElement> = (e) => {
        setAnchor(e.currentTarget)
        setOpen(true)
    }
    const closeDownload = () => {
        setOpen(false)
    }
    return (
        <Box sx={styles.container({ styleType: styleType ?? false })}>
            <Button onClick={handleOpen}>{buttonLabel}</Button>

            <Popover
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }} anchorEl={anchor} onClose={closeDownload} open={open}>
                <Box sx={styles.buttons}>
                    {
                        !!list?.length && (
                            list.map(item => (
                                <Button
                                    disabled={item.disable}
                                    sx={styles.button}
                                    onClick={() => {
                                        item.action()
                                        closeDownload()
                                    }}
                                >
                                    <Typography sx={styles.text}>{item.label}</Typography>
                                </Button>
                            ))
                        )
                    }
                </Box>
            </Popover>
        </Box>

    )
}

export { PopoverButtons }